// this is an autogenerated file from DesignSystem/PatientComms/PatientCommsContactMethods/mutationDiscussion.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_PatientComms_PatientCommsContactMethods(
  $resource: comms_thread_internal_resource!
  $thread_name: String!
  $parent_company_id: uuid!
) {
  thread: comms_threads_internal_resource_create(
    resource: $resource
    thread_name: $thread_name
    parent_company_id: $parent_company_id
  ) {
    id
    status
  }
}

`